import { render } from "./PersonSummary.vue?vue&type=template&id=78f9d3a3&scoped=true&lang=pug"
import script from "./PersonSummary.vue?vue&type=script&lang=js"
export * from "./PersonSummary.vue?vue&type=script&lang=js"

import "./PersonSummary.vue?vue&type=style&index=0&id=78f9d3a3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f9d3a3"]])

export default __exports__